import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

const state = {
    count: 10,
    Authorization: localStorage.getItem('Authorization') ? localStorage.getItem('Authorization') : ''
}
const mutations={
    add(state){
     state.count += 6
    },
    changeLogin(state, user) {

        state.Authorization = user.Authorization;

        localStorage.setItem('Authorization', user.Authorization);

    }
    // reduce(state){
    //  state.count-=1;
    // }
}
  
  
export default new Vuex.Store({
    state,
    mutations
});
  



// const store = new Vuex.Store({
//     state:{
//         login:"isNoLogin"
//     },
    // actions :{
    //     saveName({commit}, msg) {
    //         commit('saveMsg', msg)    // 提交到mutations中处理    
    //     }
    //  },
    //  mutations :{
    //     saveMsg(state, msg) {
    //        state.msg = msg;
    //    }
//           loginchange:(state,qcLogin)=> {
//         //应对界面刷新，数据会刷新为最原本的login，所以我们在这里进行一下存储
//             state.login = qcLogin
//             window.localStorage.setItem('qcLogin', state.login);
//         },
//      },
    //  getter :{
    //     showState(state) {
    //         console.log(state.msg)
    //     }
    //  }
// })
// vuex中state.msg初始化值 以后 在A组件中通过mutations更新 在B组件可以获取到更新以后的msg吗
// export default store;
// 首先声明一个状态 state
// const state = {
//     msg: '1'
//  }
//  // 然后给 actions 注册一个事件处理函数，当这个函数被触发时，将状态提交到 mutaions中处理
//  const actions = {
//     saveName({commit}, msg) {
//         commit('saveMsg', msg)    // 提交到mutations中处理    
//     }
//  }
//  // 更新状态
//  const mutations = {
//      saveMsg(state, msg) {
//         state.msg = msg;
//     }
//  }
//  // 获取状态信息
//  const getter = {
//     showState(state) {
//         console.log(state.msg)
//     }
//  }


//  // 下面这个相当关键了，所有模块，记住是所有，注册才能使用
//  export default new Vuex.Store({
//     state,
//     getter,
//     mutations,
//     actions
//  })











// WEBPACK FOOTER //
// ./src/store/store.js